import { Immutable } from "immer";
import React from "react";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

/** The slice of a reactivated serialized form the focus behavior reads. */
export type IFormWithErrors = Immutable<{
    iterator: readonly string[];
    errors: { [name: string]: readonly string[] | null } | null;
    fields: { [name: string]: { widget: { attrs: { id: string } } } };
}>;

/**
 * Focus the first errored field's input on mount (once per page load — a POST
 * that re-renders errors is a fresh mount). Derived from the serialized form
 * rather than a style-classname DOM query. Captcha errors ride a side-channel
 * outside the serialized form and get no focus.
 */
export const useFocusFirstFormError = (form: IFormWithErrors): void => {
    React.useEffect(() => {
        const firstErrorField = form.iterator.find(
            (name) => form.errors?.[name]?.length,
        );
        if (!firstErrorField) {
            return;
        }
        const id = form.fields[firstErrorField].widget.attrs.id;
        getDocument()?.getElementById(id)?.focus();
        // Mount-only by design; see above.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
